export const SHOW_ACTIVE = 'show_active';
export const SHOW_COMPLETED = 'show_completed';
export const SHOW_ACCEPTED = 'show_accepted';
